/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { ProjectListType } from "../types/ProjectTypes";

type PaginationType= {
    total: number
    page: number
    limit?: number
    pages: number
    size?:number
}
type Response = {
  payload: ProjectListType[];
  pagination_data: PaginationType;
};

export function useProjectList(params:{
  approve_status:string
}) {

    const defaultPagination = {
        total: 0,
        page: 1,
        size: 10,
        pages: 1,
    }
    const api = useApi();
    const [data, setData] = useState<ProjectListType[]>([]);
    const [paginationData, setPagination] = useState<PaginationType>(defaultPagination);
    const [isLoading, setLoading] = useState(true);
    const hasFetched = useRef(false);

    const fetchData = () => {
        setLoading(true);

        api
        .get("project/data_list_approval_project",{params})
        .then((res: SuccessFetch<Response>) => {
            const data = res.data.payload ?? [];
            setData(data);
            setPagination(res.data.pagination_data)
        })
        .catch(() => setData([]))
        .finally(() => setLoading(false));
    };

    const refetch = () => fetchData();

    useEffect(() => {
        if (hasFetched.current) return; // tidak fetch ulang
        hasFetched.current = true;
        fetchData();

        return () => {
            setData([]);
        };
        // eslint-disable-next-line
    }, []);

    return {
        data,
        isLoading,
        refetch,
        paginationData,
    };
}
